module.exports = __webpack_public_path__ + "img/horizontal_2_1_3009.88cd6c8b.png";